import React from 'react'
import { Container, Text } from './styles'
import { useConfigStore } from '../../store/config'

const Footer: React.FC = () => {
  const { config } = useConfigStore((state) => state)

  // Sem valores padrão: o rodapé mostra apenas o que está configurado
  const email = config?.footerEmail || ''
  const website = config?.footerWebsite || ''
  const address = config?.footerAddress || ''
  const phone = config?.footerPhone || ''

  const contact = [email, website].filter(Boolean).join(' | ')

  return (
    <Container>
      <Text>
        {contact && (
          <>
            {contact} <br />
          </>
        )}
        {address && (
          <>
            {address} <br />
          </>
        )}
        {phone}
      </Text>
    </Container>
  )
}

export default Footer
